<div class="page-container" style="min-height:966px;">

  <!-- Page content -->
  <div class="page-content">

    <!-- Mobile sidebar toggle -->
    <div class="visible-xs-block text-center">
      <a [attr.href]="null" (click)="showSidebar()">
        <i class="{{toogleSidebar ? 'icon-minus3' : 'icon-plus3'}}"></i>
        {{'Sidebar Menu' | translate}}
      </a>
      <br><br>
    </div>

    <!-- Main sidebar -->
    <div class="sidebar sidebar-main sidebar-default sidebar-separate">
      <div class="sidebar-content">

        <!-- Job Information -->
        <div class="sidebar-category">
          <div class="category-title">
            <p style="font-size: 18px; font-weight: bold; margin: 0 auto; text-align: center">
              <span translate>Job Information</span>
            </p>
          </div>
          <div class="category-content">
            <div class="panel panel-default">
              <div class="panel-body">
                <p><strong>{{ 'Job Name' | translate }}:</strong></p>
                <p class="text-muted">{{ theJob?.name || '-' }}</p>
                <p><strong>{{ 'Status' | translate }}:</strong></p>
                <p class="text-muted">{{ theJob?.status || '-' }}</p>
                <p><strong>{{ 'Type' | translate }}:</strong></p>
                <p class="text-muted">{{ theJob?.type || '-' }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Form Elements -->
        <div class="sidebar-category">
          <div class="category-title">
            <p style="font-size: 18px; font-weight: bold; margin: 0 auto; text-align: center">
              <span translate>Form Elements</span>
            </p>
          </div>
          <div class="category-content">
            <!-- External toolbar container -->
            <div id="external-toolbar-container" class="external-toolbar-panel">
              <!-- PDF Form Designer toolbar will be placed here -->
            </div>
          </div>
        </div>

        <!-- Selected Element Info -->
        <div class="sidebar-category" *ngIf="selectedElement">
          <div class="category-title">
            <p style="font-size: 18px; font-weight: bold; margin: 0 auto; text-align: center">
              <span translate>Selected Element</span>
            </p>
          </div>
          <div class="category-content">
            <div class="panel panel-default">
              <div class="panel-body">
                <p><strong>{{ 'Type' | translate }}:</strong></p>
                <p class="text-muted">{{ selectedElement.type }}</p>
                <p><strong>{{ 'Name' | translate }}:</strong></p>
                <p class="text-muted">{{ selectedElement.name || 'Unnamed' }}</p>
                <p><strong>{{ 'Page' | translate }}:</strong></p>
                <p class="text-muted">{{ (selectedElement.pageIndex || 0) + 1 }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="sidebar-category">
          <div class="category-title">
            <p style="font-size: 18px; font-weight: bold; margin: 0 auto; text-align: center">
              <span translate>Actions</span>
            </p>
          </div>
          <div class="category-content">
            <button class="btn btn-block btn-primary"
                    (click)="exportConfiguration()">
              <i class="icon-download"></i> {{ 'Export Configuration' | translate }}
            </button>
            <label class="btn btn-block btn-default mb-0">
              <i class="icon-upload"></i> {{ 'Import Configuration' | translate }}
              <input type="file"
                     (change)="importConfiguration($event)"
                     accept=".json"
                     style="display: none;">
            </label>
            <button class="btn btn-block btn-warning"
                    (click)="clearAllElements()"
                    [disabled]="formDesignerOptions.readOnly">
              <i class="icon-trash"></i> {{ 'Clear All Elements' | translate }}
            </button>
          </div>
        </div>

      </div>
    </div>
    <!-- /main sidebar -->

    <!-- Main content -->
    <div class="content-wrapper">

      <!-- Loading indicator -->
      <div class="loading-overlay" *ngIf="pdfLoading">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">{{ 'Loading' | translate }}...</span>
        </div>
      </div>

      <!-- Toolbar -->
  <div class="toolbar-container" *ngIf="!pdfLoading">
    <div class="toolbar-section">
      <h5>{{ theJob?.name || ('Form Designer' | translate) }}</h5>
    </div>

    <div class="toolbar-section">
      <button class="btn btn-sm btn-outline-secondary"
              (click)="onZoomOut()"
              title="{{ 'Zoom Out' | translate }}">
        <i class="icon-zoom-out"></i> -
      </button>
      <span class="zoom-level">{{ (currentZoom * 100).toFixed(0) }}%</span>
      <button class="btn btn-sm btn-outline-secondary"
              (click)="onZoomIn()"
              title="{{ 'Zoom In' | translate }}">
        <i class="icon-zoom-in"></i> +
      </button>
      <button class="btn btn-sm btn-outline-secondary"
              (click)="onResetView()"
              title="{{ 'Reset View' | translate }}">
        <i class="icon-refresh"></i>
      </button>
    </div>

    <div class="toolbar-section">
      <button class="btn btn-sm btn-outline-secondary"
              (click)="onPreviousPage()"
              [disabled]="currentPage <= 1"
              title="{{ 'Previous Page' | translate }}">
        <i class="icon-arrow-left"></i>
      </button>
      <span class="page-info">
        {{ 'Page' | translate }} {{ currentPage }} / {{ pageCount }}
      </span>
      <button class="btn btn-sm btn-outline-secondary"
              (click)="onNextPage()"
              [disabled]="currentPage >= pageCount"
              title="{{ 'Next Page' | translate }}">
        <i class="icon-arrow-right"></i>
      </button>
    </div>

    <div class="toolbar-section">
      <button class="btn btn-sm btn-outline-secondary"
              (click)="onRotateClockwise()"
              title="{{ 'Rotate' | translate }}">
        <i class="icon-rotate-right"></i>
      </button>
    </div>

    <div class="toolbar-section">
      <button class="btn btn-sm btn-outline-info"
              (click)="toggleReadOnlyMode()"
              title="{{ formDesignerOptions.readOnly ? 'Enable Editing' : 'View Only' | translate }}">
        <i [class]="formDesignerOptions.readOnly ? 'icon-pencil' : 'icon-eye'"></i>
        {{ formDesignerOptions.readOnly ? ('Edit' | translate) : ('View' | translate) }}
      </button>
    </div>

    <div class="toolbar-section">
      <button class="btn btn-sm btn-outline-warning"
              (click)="clearAllElements()"
              [disabled]="formDesignerOptions.readOnly"
              title="{{ 'Clear All' | translate }}">
        <i class="icon-trash"></i> {{ 'Clear' | translate }}
      </button>
    </div>

    <div class="toolbar-section">
      <button class="btn btn-sm btn-outline-primary"
              (click)="exportConfiguration()"
              title="{{ 'Export Configuration' | translate }}">
        <i class="icon-download"></i> {{ 'Export' | translate }}
      </button>
      <label class="btn btn-sm btn-outline-primary mb-0"
             title="{{ 'Import Configuration' | translate }}">
        <i class="icon-upload"></i> {{ 'Import' | translate }}
        <input type="file"
               (change)="importConfiguration($event)"
               accept=".json"
               style="display: none;">
      </label>
    </div>

    <div class="toolbar-section ml-auto">
      <button class="btn btn-sm btn-success"
              (click)="finishAndSend()"
              title="{{ 'Save and Send' | translate }}">
        <i class="icon-check"></i> {{ 'Send Request' | translate }}
      </button>
      <button class="btn btn-sm btn-secondary"
              (click)="closeRequest()"
              title="{{ 'Close' | translate }}">
        <i class="icon-cross"></i> {{ 'Close' | translate }}
      </button>
    </div>
  </div>

      <!-- Content area -->
      <div class="content">
        <!-- PDF Form Designer Component -->
        <div class="pdf-designer-wrapper" *ngIf="!pdfLoading && pdfSrc.url">
          <lib-pdf-form-designer
            [pdfSrc]="pdfSrc"
            [options]="formDesignerOptions"
            [externalToolbar]="true"
            [toolbarContainerId]="'external-toolbar-container'"
            [initialZoom]="currentZoom"
            [initialRotation]="currentRotation"
            [initialPage]="currentPage"
            (configurationChange)="onConfigurationChange($event)"
            (elementSelected)="onElementSelected($event)"
            (elementAdded)="onElementAdded($event)"
            (elementModified)="onElementModified($event)"
            (elementRemoved)="onElementRemoved($event)"
            (zoomChange)="onZoomChange($event)"
            (rotationChange)="onRotationChange($event)"
            (pageChange)="onPageChange($event)"
            (toolbarReady)="onToolbarReady($event)">
          </lib-pdf-form-designer>
        </div>
      </div>
      <!-- /content area -->

    </div>
    <!-- /main content -->

  </div>
  <!-- /page content -->

</div>
